import React, { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { Row } from 'reactstrap';
import { Colxx } from '../../components/common/CustomBootstrap';
import { isRentalRelatedStatuse } from '../../helpers/statuses';
import {
  convertBooleanToYesOrNo,
  formatReturnStatus,
  formatUrl,
  getFormattedDateString,
  getFormattedMoneyString,
} from '../../helpers/utils';
import productAPI from '../../services/API/product';
import { BasicDetailItem } from '../../components/common/BasicDetailItem';

export const BasicProductProfile = ({ productData, additionalFields }) => {
  const [loadingImages, setLoadingImages] = useState(false);
  const [image, setImage] = useState(null);

  useEffect(() => {
    setLoadingImages(true);
    let isMounted = true;
    productAPI
      .getProductImages(productData.id)
      .then((data) => {
        if (!isMounted) return null;

        let primaryImage = data.find((img) => img.img_primary);
        setImage(primaryImage.img_url ?? '');
      })
      .catch(() => {
        // setLoadingImages(null);
      })
      .finally(() => {
        if (!isMounted) return null;

        setLoadingImages(false);
      });

    return () => {
      isMounted = false;
    };
  }, [productData.id]);

  let additionals = [];
  if (Array.isArray(additionalFields)) {
    additionals = additionalFields.map(({ label, field }, index) => (
      <BasicDetailItem
        label={label.toUpperCase()}
        value={productData[field]}
        key={`bdi_${index}`}
      />
    ));
  }

  if (isRentalRelatedStatuse(productData.status ?? '')) {
    // related to the rentals
    let insuranceField = (
      <BasicDetailItem
        label='INSURANCE'
        value={convertBooleanToYesOrNo(productData.insurance)}
      />
    );
    additionals.push(insuranceField);
  }

  return (
    <Row className='mt-4 '>
      <Colxx xxs='12' md='8' xl='7' lg='8' className='mb-4'>
        <div className='section-header'>
          <div className='section-title'>
            <h3 style={{ color: '#C98B76', fontFamily: 'Brown' }}>
              Product Details
            </h3>
          </div>
        </div>

        <div className='inventory-detail-wrapper'>
          <BasicDetailItem label='ID' value={productData.id} />
          <BasicDetailItem
            label='TITLE'
            value={productData.title || productData.product_title || '-'}
          />
          <BasicDetailItem label='SIZE' value={productData.size} />
          <BasicDetailItem label='COLOR' value={productData.color} />
          <BasicDetailItem label='GENDER' value={productData.gender} />
          <BasicDetailItem
            label='PRICE'
            value={productData.price ? `$${productData.price}` : ''}
          />

          <BasicDetailItem label='BRAND' value={productData.brand} />

          <BasicDetailItem
            label='DESCRIPTION'
            value={productData.description}
          />

          <BasicDetailItem
            label='FOR SALE'
            value={convertBooleanToYesOrNo(productData.for_sale)}
          />
          {/* <BasicDetailItem
            label='RENT EARNING/WEEK'
            value={getFormattedMoneyString(productData.rent_earnings_per_week)}
          /> */}
          {productData.last_rented_on ? (
            <BasicDetailItem
              label='RENTED ON'
              value={getFormattedDateString(productData.last_rented_on)}
            />
          ) : null}
          {/* <BasicDetailItem
            label='Rent until'
            value={getFormattedDateString(productData.rented_until)}
          /> */}

          <BasicDetailItem label='CATEGORY' value={productData.category} />

          {/* <BasicDetailItem
            label='COMPLAINT'
            value={convertBooleanToYesOrNo(productData.complaint)}
          />

          <BasicDetailItem
            label='CONSIGNMENT CANCELLED'
            value={convertBooleanToYesOrNo(productData.consignment_cancelled)}
          /> */}

          {additionals}
          <BasicDetailItem
            label='STATUS'
            value={
              productData.status ? formatReturnStatus(productData.status) : ''
            }
            style={{
              paddingLeft: 10,
              paddingRight: 10,
              backgroundColor: productData?.status_color_code_user || '#000000',
              color: '#ffffff',
              borderRadius: 10,
            }}
          />
          {/* <BasicDetailItem
            label={'ADMIN NOTE'}
            value={productData.admin_notes || '-'}
          /> */}
        </div>
      </Colxx>

      <Colxx xxs='12' md='8' lg='8' xl='5' className='mb-4'>
        {productData.shopify_product_url && (
          <div className='capitalize mb-2'>
            <a
              href={formatUrl(productData.shopify_product_url)}
              target='blank'
              className='btn-link'
              color='link'
              style={{ color: '#C98B76', fontFamily: 'Brown' }}
            >
              View on Store
            </a>
          </div>
        )}

        <div>
          <div className='inventory-detail-wrapper'>
            {loadingImages ? (
              <Skeleton width={160} height={160} className='d-block mb-2' />
            ) : image && image !== 'undefined' ? (
              <div
                className='main-product-img-wrapper border'
                style={{ height: 250 }}
              >
                <img
                  src={image}
                  alt=''
                  className='product-main-img'
                  style={{
                    height: '100%',
                    width: '100%',
                    objectFit: 'contain',
                  }}
                  loading={'lazy'}
                />
              </div>
            ) : (
              'No primary image'
            )}
          </div>
        </div>
      </Colxx>
    </Row>
  );
};
